<template>
  <div>


<el-container>
      <!-- 顶部 -->
  <el-header> 
    <div>
      <div class="bamtopclass">专业老师管理系统</div>
      <div class="removeLogin"><el-button type="primary" @click="outlogin"> 退出登录</el-button></div>
      <div><span class="username">{{username}}</span></div>
    </div>
    

   
  </el-header>
  <el-container class="home_class">
    <el-aside width="200px">
          <!-- 左侧 -->
    <el-menu router>
      <!-- 一级菜单 -->
      <el-submenu index="1">
          <!-- 一级菜单模块区域 -->
        <template slot="title">
              <!-- 图标 -->
          <span class="iconfont icon-xueshengguanli"></span>
          <span>工作汇报</span>
        </template>
          <!-- 二级菜单 -->
        <el-menu-item-group>
          <el-menu-item index="pPerformance">
             <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">填写绩效</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>
    
        <el-menu-item-group>
          <el-menu-item index="viewWeekPPerformance">
             <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">查看周绩效</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>
        <el-menu-item-group>
          <el-menu-item index="viewMonthPPerformance">
             <template slot="title">
              <!-- 图标 -->
         <span class="iconfont icon-wentihuibao"></span>
          <span @click="report">查看月绩效</span>
        </template>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>

    </el-menu>
 
    </el-aside>

    <el-container>
      <el-main>

        <router-view></router-view>
        
        </el-main>
      <el-footer>Footer</el-footer>
    </el-container>
  </el-container>
</el-container>
  </div>
</template>

<script>
import "@/components/work/until/icon/iconfont.css"
export default {
  created(){
    this.newscli()
  },
  methods:{
    newscli(){
      this.username=JSON.parse(localStorage.getItem('user')).username 
    },
    report(){
    
    },
    outlogin(){
      localStorage.removeItem('user');
      localStorage.removeItem('token');
       this.$router.push({  
                    name: 'Login',  
                  })
    }
  },data(){
      return{
        username:''
      }}

}
</script>

<style scoped>
 .el-header, .el-footer {
    background-color: #B3C0D1;
    color: #333;
    text-align: center;
    line-height: 60px;
  }
  
  .el-aside {
    background-color: #D3DCE6;
    color: #333;
    line-height: 200px;
  }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
    text-align: center;
 
  }
  .home_class{
    height: 800px;
  }
  .removeLogin{
   float:right;
  }
 .bamtopclass{
  float: left;
  padding-left: 45%;
 }.username{
  padding-left: 38%;
}
</style>


// WEBPACK FOOTER //
// src/components/work/professionalTeacher/ProfessionalTeacherBam.vue